export const MSP_LOCALES = {
  en: 'en_US',
  nl: 'nl_NL',
  it: 'it_IT',
};
